
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Arrays`}</h1>
<p>{`Use literal syntax for array creation.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const items =  new Array();

// Good
const items = [];
`}</code></pre>
<p>{`Use `}<inlineCode parentName="p">{`slice()`}</inlineCode>{` to clone an array instead of array spread `}<inlineCode parentName="p">{`...`}</inlineCode>{`.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? It leads to more consistent code because it can also be used when chaining array methods that will mutate the original array. E.g: `}<inlineCode parentName="p">{`sort`}</inlineCode></p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`const items = [2, 4, 3, 10];
const copy = items.slice();
const sortedArray = items.slice().sort();
`}</code></pre>
<p>{`To convert an iterable object into an array, use array spread `}<inlineCode parentName="p">{`...`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{}}>{`const Component = ({ children }) => {
  const childrenItems = [...children];
  // ... render
};
`}</code></pre>
<p>{`Always favor array methods over `}<inlineCode parentName="p">{`for`}</inlineCode>{` loops.`}</p>
<pre><code parentName="pre" {...{}}>{`const items = [1, 2, 3, 4];

// Bad
const newArray = [];

for (let item of items) {
  newArray.push(item * 2);
}

// Good
const newArray = items.map((item) => item * 2);
`}</code></pre>
<p>{`If the index and the item is necessary, always favor `}<inlineCode parentName="p">{`forEach`}</inlineCode>{` over a `}<inlineCode parentName="p">{`foor`}</inlineCode>{` loop.`}</p>
<pre><code parentName="pre" {...{}}>{`const items = [1, 2, 3, 4];

// Bad
let index = 0;
for (let item of items) {
  console.log('Item', item, 'at index', index);
  index += 1;
}

// Good
items.forEach((item, index) => {
  console.log('Item', item, 'at index', index);
});
`}</code></pre>
<p>{`If array methods are needed for an iterable object, always perform the transformation into an array at the point of usage.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const items = [...iterableLike];
items.forEach(console.log);

// Good
[...iterableLike].forEach(console.log);
`}</code></pre>
<p>{`Always use array destructuring when accessing items of an array.`}</p>
<pre><code parentName="pre" {...{}}>{`const items = [1, 2];

// Bad
const item1 = items[0];
const item3 = items[1];

// Good
const [ item1, item2 ] = items;
`}</code></pre>
<p>{`Never use `}<inlineCode parentName="p">{`_`}</inlineCode>{` for unused items in an array when destructuring, use empty commas instead.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? `}<inlineCode parentName="p">{`_`}</inlineCode>{` doesn't have a special meaning, it's just another name for a variable. If used once, it can't be used again.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`const items = [1, 2, 3, 4];

// Bad
const [ item1, _, item3 ] = items;
const [ item1, _, _, item4 ] = items;  // will trigger an error

// Good
const [ item1, , item3 ] = items;
const [ item1, , , item3 ] = items;
`}</code></pre>
<p>{`When using array methods that mutate the array, always clone the array first.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad 
items.sort((a, b) => a b);

// Good
items.slice().sort((a, b) => a b);
`}</code></pre>
<p>{`When adding new items to an array, always favor using the spread operator `}<inlineCode parentName="p">{`...`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`push()`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
items.push(5);

// Good
const newArray = [...items, 5];
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;